<button class="scroll-to-top-button ripple" *ngIf="(showButton$ | async)" [@fadeInOut] (click)="scrollToTopClick()"
  appScrollToTopPositioner>
  <i class="fa fa-arrow-up" aria-hidden="true"></i>
</button>
